<app-call-waiter-indicator
  type="assistance"
  class="bell"
  [class.active]="callWaiterLaneAssistance()"
/>

<span class="text">Need Lane Assistance</span>
@if (callWaiterLaneAssistance()) {
  <div class="info">
    A team member will be with you shortly. <span>Tap to cancel.</span>
  </div>
} @else {
  <span class="action">Tap here</span>
}
